import { mapState } from "vuex";
import { getData } from "@/services/axios";
import { dragscroll } from "vue-dragscroll";
import { dashboardTableList } from "@/consts/dashboardTableList";
const __default__ = {
  name: "AllClassAbsenceCounter",
  filters: {
    zeroFallback(val) {
      return val ? val : 0;
    }

  },
  directives: {
    dragscroll: dragscroll
  },
  data: () => ({
    dashboardTableList: dashboardTableList,
    isLoading: true,
    absenceByClassroom: [],
    intervalId: null
  }),
  computed: { ...mapState(["school", "grades"])
  },

  created() {
    this.setData();
  },

  mounted() {
    // コンポーネントがマウントされたときにすぐにデータを取得してからintervalを開始
    this.getAttendanceSummary();
    this.intervalId = setInterval(() => {
      // データを取得
      this.getAttendanceSummary(); // 親コンポーネントのcurrentDtを更新

      this.$emit("update-time");
    }, 1000 * 60 * 1);
  },

  beforeDestroy() {
    // intervalをクリーンアップ
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  },

  methods: {
    decimalAlignmentPercent(count, studentsCount) {
      return count ? "(" + Math.round(count / studentsCount * 1000) / 10 + "%)" : "";
    },

    setData: function () {
      this.getAttendanceSummary();
    },
    getAttendanceSummary: async function () {
      const data = await getData("attendance_summaries_classrooms?dashboard=1");
      const summaries = data.items;
      const classroomList = this.classrooms.map(v => {
        const _v = Object.assign({}, v);

        _v["absence"] = summaries[v.id] ? summaries[v.id] : {};
        return _v;
      }); // 全校のabsenceの計算

      const schoolTotalAbsence = classroomList.reduce((absence, v) => {
        Object.keys(v["absence"]).forEach(key => {
          if (key in absence) {
            absence[key] += v["absence"][key];
          } else {
            absence[key] = v["absence"][key];
          }
        });
        return absence;
      }, {});
      this.absenceByClassroom = [{
        name: "全校",
        students_count: this.totalStudentCount,
        absence: schoolTotalAbsence
      }, ...classroomList];
      this.$emit("update-summary", {
        total: schoolTotalAbsence.total || 0,
        lunchSkip: schoolTotalAbsence["給食不要"] || 0
      });
      this.isLoading = false;
    }
  }
};
import { storeToRefs } from "pinia";
import { useGradeClassroomStore } from "@/stores/gradeClassroom";
export default /*#__PURE__*/Object.assign(__default__, {
  setup(__props, {
    expose
  }) {
    const {
      classrooms,
      totalStudentCount
    } = storeToRefs(useGradeClassroomStore());
    expose({
      classrooms,
      totalStudentCount
    });
    return {
      __sfc: true,
      classrooms,
      totalStudentCount,
      dashboardTableList
    };
  }

});